
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c6.616 0 12 5.384 12 12s-5.384 12-12 12S4 22.616 4 16 9.384 4 16 4zm0 2C10.465 6 6 10.465 6 16s4.465 10 10 10 10-4.465 10-10S21.535 6 16 6zm0 4c2.197 0 4 1.803 4 4a3.808 3.808 0 01-2.594 3.594l-.406.125V19h-2v-1.281c0-.856.56-1.635 1.375-1.906l.406-.125A1.779 1.779 0 0018 14c0-1.117-.883-2-2-2s-2 .883-2 2h-2c0-2.197 1.803-4 4-4zm-1 10h2v2h-2v-2z"}})])
          )
        }
      }
    